import * as React from "react";
import { forwardRef } from "react";
const SvgSource = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Iconsax/Linear/exportsquare" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M13.7998 11L21.9998 2.8M22.7998 6.8V2H17.9998M11.7998 2H9.7998C4.7998 2 2.7998 4 2.7998 9V15C2.7998 20 4.7998 22 9.7998 22H15.7998C20.7998 22 22.7998 20 22.7998 15V13", stroke: "#05A35C", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgSource);
export default ForwardRef;
